import { useQuery } from 'react-query'
import EmailConfigService from '../services/EmailConfigService'

export const useEmailConfig = () => {
  const { data: emailConfig } = useQuery(
    ['email-config'],
    async () => await EmailConfigService.getConfig(),
    {
      refetchOnWindowFocus: false,
    }
  )

  return emailConfig
}
